/* globals global */
import Backbone from 'backbone';

global.EasyPost = global.EasyPost || {};

export default Backbone.Collection.extend({
  firstFetchSuccess: false,

  constructor(models, options = {}) {
    this.listenToOnce(this, 'sync', () => this.firstFetchSuccess = true);
    Backbone.Collection.prototype.constructor.call(this, models, options);
  },

  create(attributes, options = {}) {
    const thisOptions = { ...options, wait: true };
    Backbone.Collection.prototype.create.apply(this, [attributes, thisOptions]);
  },

  fetch(options = {}) {

    const thisOptions = {
      data: {},
      ...options,
    };

    let paginationParams = {};
    if (options.paginationParams) {
      paginationParams = {
        ...options.paginationParams,
      };

      delete thisOptions.paginationParams;
    }

    Backbone.$.extend(thisOptions.data, paginationParams, this.paramsForFetch());

    return Backbone.Collection.prototype.fetch.call(this, thisOptions);
  },

  parse(response) {
    if (this.key) return response[this.key];
    return response;
  },

  paramsForFetch() { return {}; },
});



// WEBPACK FOOTER //
// ./app/collections/base.js